(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cp-finder-detail"]) return;
  try {
    
  (function () {
    function updateFinderReturnLinks() {
      var links = document.querySelectorAll('[data-cp-finder-return]');
      if (!links.length) return;
      try {
        var saved = sessionStorage.getItem('cp_pf_return_url');
        if (!saved) return;
        var fallback = new URL(links[0].getAttribute('href'), window.location.origin);
        var destination = new URL(saved, window.location.origin);
        if (destination.origin !== window.location.origin || destination.pathname !== fallback.pathname) return;
        var selection = new URLSearchParams();
        ['equipment_type', 'make', 'model', 'variant'].forEach(function (key) {
          var value = destination.searchParams.get(key);
          if (value) selection.set(key, value);
        });
        destination.search = selection.toString();
        destination.hash = '';
        links.forEach(function (link) { link.href = destination.href; });
      } catch (error) {}
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', updateFinderReturnLinks, { once: true });
    else updateFinderReturnLinks();
    document.addEventListener('shopify:section:load', updateFinderReturnLinks);
    window.addEventListener('pageshow', updateFinderReturnLinks);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
